<button class="btn-dots"
        [disabled]="disabled"
        [class.active]="activated">
    <span></span>
    <span></span>
    <span></span>
</button>
